import { LoadingOutlined_str } from '@zenlayer/zen-design-icons';
import { useClickAway, useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React, { useMemo, useRef } from 'react';
import insertRipple from '../_util/insertRipple';
import { pickDomAttrs } from '../_util/utils';
import Explain from '../explain';
import SvgIcon from '../svg-icon';
import Tooltip from '../tooltip';
import Group from './chips-group';
import ChipsNumber from './chips-number';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Chips = props => {
  const {
    type = 'outline',
    size = 'm',
    prefix,
    suffix,
    disabled,
    readonly,
    loading,
    error,
    tooltips,
    noPadding,
    mText,
    width,
    height,
    children,
    defaultActive: propsDefaultActive,
    active: propsActive,
    onActiveChange: propsOnActiveChange,
    onClick,
    sendChildrenProps,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    wrapClassName,
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-chips");
  const canDoSomething = !disabled && !readonly && !loading;
  const chipsRef = useRef(null);
  const [active, onActiveChange] = useControllableValue(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultActive',
    valuePropName: 'active',
    trigger: 'onActiveChange'
  });
  useClickAway(event => {
    canDoSomething && onActiveChange(false, event);
  }, chipsRef);
  const prefixIcon = useMemo(() => {
    return prefix ? /*#__PURE__*/React.cloneElement(prefix, {
      className: classNames(prefix.props.className, "".concat(baseClassName, "-prefixIcon"), {
        mText
      })
    }) : null;
  }, [prefix, mText]);
  const suffixIcon = useMemo(() => {
    if (loading) {
      return /*#__PURE__*/_jsx("div", {
        className: classNames("".concat(baseClassName, "-suffixIcon"), {
          mText
        }),
        children: /*#__PURE__*/_jsx(SvgIcon, {
          spin: true,
          svgStr: LoadingOutlined_str,
          style: {
            display: 'block'
          }
        })
      });
    }
    return suffix ? /*#__PURE__*/React.cloneElement(suffix, {
      className: classNames(suffix.props.className, "".concat(baseClassName, "-suffixIcon"), {
        mText
      })
    }) : null;
  }, [suffix, loading, mText]);

  //sendChildrenProps,如果Children是一个组件，则给他传一些状态
  const childrenProps = sendChildrenProps ? {
    type,
    size,
    disabled,
    readonly,
    loading,
    error,
    active,
    onActiveChange
  } : undefined;
  const tooltipProps = useMemo(() => {
    let props = {};
    if (!!tooltips) {
      props = {
        title: tooltips
      };
    }
    return props;
  }, [tooltips]);
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsx(Explain, {
    helperText: error === true ? undefined : error,
    wrapClassName: wrapClassName,
    children: /*#__PURE__*/_jsxs("div", {
      ...restProps,
      className: classNames(baseClassName, className, {
        ["".concat(baseClassName, "-").concat(type)]: !!type,
        ["".concat(baseClassName, "-").concat(size)]: !!size,
        ["".concat(baseClassName, "-active")]: !!active,
        ["".concat(baseClassName, "-disabled")]: !!disabled,
        ["".concat(baseClassName, "-readonly")]: !!readonly,
        ["".concat(baseClassName, "-loading")]: !!loading,
        ["".concat(baseClassName, "-error")]: !!error,
        ["".concat(baseClassName, "-with-prefixIcon")]: !!prefixIcon,
        ["".concat(baseClassName, "-with-suffixIcon")]: !!suffixIcon
      }),
      ref: ref => {
        insertRipple({
          ref
        });
        chipsRef.current = ref;
      },
      style: {
        width,
        height: height !== null && height !== void 0 ? height : mText ? 'auto' : undefined,
        minHeight: mText,
        ...style
      },
      onClick: e => {
        if (canDoSomething) {
          onActiveChange(true);
          onClick === null || onClick === void 0 || onClick(e);
        }
      },
      children: [prefixIcon, suffixIcon, /*#__PURE__*/_jsx(Tooltip, {
        placement: "top",
        title: undefined,
        getPopupContainer: target => target.parentNode,
        ...tooltipProps,
        children: /*#__PURE__*/_jsx("div", {
          className: classNames("".concat(baseClassName, "-content"), {
            noPadding
          }),
          children: /*#__PURE__*/React.isValidElement(children) ? /*#__PURE__*/React.cloneElement(children, childrenProps) : children
        })
      })]
    })
  });
};
Chips.Number = ChipsNumber;
Chips.Group = Group;
export default Chips;